export default __webpack_public_path__ + "static/media/partly-cloudy.feaec676.jpg";